// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Button, Card, Container, Form, Table, Modal, InputGroup, Row, Col, Pagination } from 'react-bootstrap';

// const UserDetails = () => {
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [editUser, setEditUser] = useState(null);
//   const [formData, setFormData] = useState({ status: '' });

//   const [searchTerm, setSearchTerm] = useState('');
//   const [searchResult, setSearchResult] = useState([]);
//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const response = await axios.get('http://localhost:4001/users');
//       setUsers(response.data);
//     } catch (error) {
//       console.error('Error fetching users:', error);
//     }
//   };

//   const handleEdit = async (userId) => {
//     try {
//       const response = await axios.get(`http://localhost:4001/user/${userId}`);
//       setEditUser(response.data);
//       setFormData({ status: response.data.status });
//       setShowEditModal(true);
//     } catch (error) {
//       console.error('Error fetching user details:', error);
//     }
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setEditUser(null);
//     setFormData({ status: '' });
//   };

//   const handleUpdateUser = async () => {
//     try {
//       await axios.put(`http://localhost:4001/user/${editUser.Id}/status`, { status: formData.status });
//       fetchUsers();
//       setShowEditModal(false);
//       setEditUser(null);
//       setFormData({ status: '' });
//     } catch (error) {
//       console.error('Error updating user status:', error);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSearch = (value) => {
//     setSearchTerm(value);
//     const filteredUsers = users.filter((user) =>
//       user.email.toLowerCase().includes(value.toLowerCase()) ||
//       user.mobile.toString().includes(value)
//     );
//     setSearchResult(filteredUsers);
//     setCurrentPage(1); // Reset to the first page after the search
//   };

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = (searchTerm ? searchResult : users).slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil((searchTerm ? searchResult.length : users.length) / itemsPerPage);

//   return (
//     <Container fluid>
//       <Card>
//         <Card.Text className='m-3' style={{ fontSize: '26px', fontWeight: '400' }}>User Details</Card.Text>

//         <Card.Subtitle className='m-3 mt-0 text-muted'>
//           <Row className='justify-content-md-center'>
//             <Col lg={10} sm={12}>
//               <InputGroup>
//                 <Form.Control
//                   placeholder='Search by email or mobile'
//                   aria-label='searchBar'
//                   aria-describedby='basic-addon2'
//                   value={searchTerm} onChange={(e) => handleSearch(e.target.value)}
//                 />
//                 <InputGroup.Text id='basic-addon2' style={{ fontSize: 'smaller' }}>search</InputGroup.Text>
//               </InputGroup>
//             </Col>
//           </Row>
//         </Card.Subtitle>

//         <Card.Text>
//           <Table striped hover size="sm" className='mt-3 table-borderless'>
//             <thead>
//               <tr>
//                 <th className='text-muted'></th>
//                 <th className='text-secondary text-uppercase fw-light' style={{ fontSize: 'smaller', textAlign: 'left' }}>First Name</th>
//                 <th className='text-secondary text-uppercase fw-light' style={{ fontSize: 'smaller', textAlign: 'left' }}>Last Name</th>
//                 <th className='text-secondary text-uppercase fw-light' style={{ fontSize: 'smaller', textAlign: 'left' }}>Email</th>
//                 <th className='text-secondary text-uppercase fw-light' style={{ fontSize: 'smaller', textAlign: 'left' }}>Mobile</th>
//                 <th className='text-secondary text-uppercase fw-light' style={{ fontSize: 'smaller', textAlign: 'left' }}>City</th>
//                 <th className='text-secondary text-uppercase fw-light' style={{ fontSize: 'smaller', textAlign: 'left' }}>DOB</th>
//                 <th className='text-secondary text-uppercase fw-light' style={{ fontSize: 'smaller', textAlign: 'left' }}>Gender</th>
//                 <th className='text-secondary text-uppercase fw-light' style={{ fontSize: 'smaller', textAlign: 'left' }}>Status</th>
//                 <th className='text-secondary text-uppercase fw-light' style={{ fontSize: 'smaller', textAlign: 'left' }}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentItems.map((user, index) => (
//                 <tr key={user.Id}>
//                   <td className='p-2 text-muted'>{index + 1 + indexOfFirstItem}</td>
//                   <td className='p-2' style={{ textAlign: 'left' }}>{user.FirstName}</td>
//                   <td className='p-2' style={{ textAlign: 'left' }}>{user.LastName}</td>
//                   <td className='p-2' style={{ textAlign: 'left' }}>{user.email}</td>
//                   <td className='p-2' style={{ textAlign: 'left' }}>{user.mobile}</td>
//                   <td className='p-2' style={{ textAlign: 'left' }}>{user.city}</td>
//                   <td className='p-2' style={{ textAlign: 'left' }}>{user.dob}</td>
//                   <td className='p-2' style={{ textAlign: 'left' }}>{user.gender}</td>
//                   <td className='p-2' style={{ textAlign: 'left' }}>{user.status}</td>
//                   <td className='p-2'>
//                     <Button className='m-0 p-0' variant='none' onClick={() => handleEdit(user.Id)}>
//                       <i className="bi bi-pencil-square" style={{ color: 'blue' }}></i>
//                     </Button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>

//           <Pagination>
//             <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//             <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => handlePageChange(index + 1)}>
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//             <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//           </Pagination>

//         </Card.Text>
//       </Card>

//       <Modal show={showEditModal} onHide={handleCloseEditModal} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Edit User Status</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group className="mb-3" controlId="editStatus">
//               <Form.Label>Status</Form.Label>
//               <Form.Control as="select" name="status" value={formData.status} onChange={handleChange}>
//                 <option value="Verified">Verified</option>
//                 <option value="Pending">Pending</option>
//                 <option value="Blocked">Blocked</option>
//               </Form.Control>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleUpdateUser}>
//             Update
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// };

// export default UserDetails;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Button, Card, Container, Form, Table, Modal, InputGroup, Row, Col, Pagination } from 'react-bootstrap';
// import './UserDetails.css';

// const UserDetails = () => {
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [editUser, setEditUser] = useState(null);
//   const [formData, setFormData] = useState({ status: '' });

//   const [searchTerm, setSearchTerm] = useState('');
//   const [searchResult, setSearchResult] = useState([]);

//   // View-Orders modal state
//     const [showViewModal, setShowViewModal] = useState(false);
//     const [viewUser, setViewUser] = useState(null);
//     const [viewOrders, setViewOrders] = useState([]);

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const response = await axios.get('http://localhost:4001/users');
//       setUsers(response.data);
//     } catch (error) {
//       console.error('Error fetching users:', error);
//     }
//   };

//   const handleEdit = async (userId) => {
//     try {
//       const response = await axios.get(`http://localhost:4001/user/${userId}`);
//       setEditUser(response.data);
//       setFormData({ status: response.data.status });
//       setShowEditModal(true);
//     } catch (error) {
//       console.error('Error fetching user details:', error);
//     }
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setEditUser(null);
//     setFormData({ status: '' });
//   };

//   const handleUpdateUser = async () => {
//     try {
//       await axios.put(`http://localhost:4001/user/${editUser.Id}/status`, { status: formData.status });
//       fetchUsers();
//       setShowEditModal(false);
//       setEditUser(null);
//       setFormData({ status: '' });
//     } catch (error) {
//       console.error('Error updating user status:', error);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSearch = (value) => {
//     setSearchTerm(value);
//     const filteredUsers = users.filter((user) =>
//       user.email.toLowerCase().includes(value.toLowerCase()) ||
//       user.mobile.toString().includes(value)
//     );
//     setSearchResult(filteredUsers);
//     setCurrentPage(1); // Reset to the first page after the search
//   };

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = (searchTerm ? searchResult : users).slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil((searchTerm ? searchResult.length : users.length) / itemsPerPage);

//   // Summary counts (adapted from ServitorDetails)
//   const verifiedCount = users.filter((user) => user.status === 'Verified').length;
//   const pendingCount = users.filter((user) => user.status === 'Pending').length;
//   const blockedCount = users.filter((user) => user.status === 'Blocked').length;

//   // ------------- View Orders Handlers -------------
//     const handleViewOrders = async (user) => {
//       try {
//         const resp = await axios.get(
//           `http://localhost:4001/user/${user.Id}/orders`
//         );
//         setViewUser(user);
//         setViewOrders(resp.data);
//         setShowViewModal(true);
//       } catch (err) {
//         console.error('Error fetching user orders:', err);
//       }
//     };
//     const handleCloseViewModal = () => {
//       setShowViewModal(false);
//       setViewUser(null);
//       setViewOrders([]);
//     };

//   return (
//     <Container fluid className="adminUserdetails-container">
//       <Card className="adminUserdetails-card">
//         <Card.Body>
//           <Card.Title className="adminUserdetails-title">User Details</Card.Title>

//           {/* Summary Cards (adapted) */}
//           <div className="adminUserdetails-summary-cards">
//             <div className="adminUserdetails-summary-card adminUserdetails-verified-card">
//               <div>
//                 <p className="adminUserdetails-detail-text">Total Verified</p>
//                 <p className="adminUserdetails-count-value">{verifiedCount}</p>
//               </div>
//             </div>
//             <div className="adminUserdetails-summary-card adminUserdetails-pending-card">
//               <div>
//                 <p className="adminUserdetails-detail-text">Total Pending</p>
//                 <p className="adminUserdetails-count-value">{pendingCount}</p>
//               </div>
//             </div>
//             <div className="adminUserdetails-summary-card adminUserdetails-blocked-card">
//               <div>
//                 <p className="adminUserdetails-detail-text">Total Blocked</p>
//                 <p className="adminUserdetails-count-value">{blockedCount}</p>
//               </div>
//             </div>
//           </div>

//           {/* Filters and Search */}
//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by email or mobile"
//                   value={searchTerm}
//                   onChange={(e) => handleSearch(e.target.value)}
//                   className="adminUserdetails-search"
//                 />
//                 <InputGroup.Text>search</InputGroup.Text>
//               </InputGroup>
//             </Col>
//           </Row>

//           {/* Table with Scrollable Wrapper */}
//           <div className="adminUserdetails-table-wrapper">
//             <Table striped bordered hover responsive className="adminUserdetails-table">
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>First Name</th>
//                   <th>Last Name</th>
//                   <th>Email</th>
//                   <th>Mobile</th>
//                   <th>City</th>
//                   <th>DOB</th>
//                   <th>Gender</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.map((user, index) => (
//                   <tr key={user.Id}>
//                     <td>{index + 1 + indexOfFirstItem}</td>
//                     <td>{user.FirstName}</td>
//                     <td>{user.LastName}</td>
//                     <td>{user.email}</td>
//                     <td>{user.mobile}</td>
//                     <td>{user.city}</td>
//                     <td>{user.dob}</td>
//                     <td>{user.gender}</td>
//                     <td>
//                       <span
//                         className={`adminUserdetails-badge-${user.status.toLowerCase()}`}
//                       >
//                         {user.status}
//                       </span>
//                     </td>
//                     <td>

//                       {/* View Orders */}
//                                             <Button
//                                               variant="outline-info"
//                                               size="sm"
//                                               className="adminUserdetails-action-btn me-1"
//                                               onClick={() => handleViewOrders(user)}
//                                             >
//                                               <i className="bi bi-eye"></i>
//                                             </Button>

//                       <Button
//                         variant="outline-primary"
//                         size="sm"
//                         className="adminUserdetails-action-btn"
//                         onClick={() => handleEdit(user.Id)}
//                       >
//                         <i className="bi bi-pencil-square" style={{ color: 'blue' }}></i>
//                       </Button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>

//           {/* Pagination */}
//           <Pagination className="adminUserdetails-pagination">
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       <Modal show={showEditModal} onHide={handleCloseEditModal} centered className="adminUserdetails-modal">
//         <Modal.Header closeButton className="adminUserdetails-modal-header">
//           <Modal.Title>Edit User Status</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminUserdetails-modal-body">
//           <Form>
//             <Form.Group className="mb-3" controlId="editStatus">
//               <Form.Label className="adminUserdetails-form-label">Status</Form.Label>
//               <Form.Control
//                 as="select"
//                 name="status"
//                 value={formData.status}
//                 onChange={handleChange}
//                 className="adminUserdetails-form-control"
//               >
//                 <option value="Verified">Verified</option>
//                 <option value="Pending">Pending</option>
//                 <option value="Blocked">Blocked</option>
//               </Form.Control>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer className="adminUserdetails-modal-footer">
//           <Button
//             variant="secondary"
//             onClick={handleCloseEditModal}
//             className="adminUserdetails-footer-btn adminUserdetails-footer-btn-close"
//           >
//             Close
//           </Button>
//           <Button
//             variant="primary"
//             onClick={handleUpdateUser}
//             className="adminUserdetails-footer-btn adminUserdetails-footer-btn-save"
//           >
//             Update
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* View Orders Modal */}
//             <Modal
//               show={showViewModal}
//               onHide={handleCloseViewModal}
//               size="lg"
//               centered
//               className="adminUserdetails-modal"
//             >
//               <Modal.Header closeButton className="adminUserdetails-modal-header">
//                 <Modal.Title>
//                   Orders for {viewUser?.FirstName} {viewUser?.LastName} (
//                   {viewOrders.length})
//                 </Modal.Title>
//               </Modal.Header>
//               <Modal.Body className="adminUserdetails-modal-body">
//                 {viewOrders.length === 0 ? (
//                   <p className="text-center text-muted">No orders found.</p>
//                 ) : (
//                   <Table striped hover size="sm">
//                     <thead>
//                       <tr>
//                         <th>#</th>
//                         <th>Order #</th>
//                         <th>Service</th>
//                         <th>Status</th>
//                         <th>Price</th>
//                         <th>Date</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {viewOrders.map((o, i) => (
//                         <tr key={o.order_number || i}>
//                           <td>{i + 1}</td>
//                           <td>{o.order_number}</td>
//                           <td>{o.Service?.services_name || o.service_name}</td>
//                           <td>{o.status}</td>
//                           <td>{o.price}</td>
//                           <td>
//                             {new Date(o.created_at).toLocaleDateString()}{' '}
//                             {new Date(o.created_at).toLocaleTimeString()}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                 )}
//               </Modal.Body>
//               <Modal.Footer className="adminUserdetails-modal-footer">
//                 <Button
//                   variant="secondary"
//                   onClick={handleCloseViewModal}
//                   className="adminUserdetails-footer-btn adminUserdetails-footer-btn-close"
//                 >
//                   Close
//                 </Button>
//               </Modal.Footer>
//             </Modal>

//     </Container>
//   );
// };

// export default UserDetails;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Button,
//   Card,
//   Container,
//   Form,
//   Table,
//   Modal,
//   InputGroup,
//   Row,
//   Col,
//   Pagination,
// } from "react-bootstrap";
// import "./UserDetails.css";
// import { URL } from "../../../config";

// const UserDetails = () => {
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [editUser, setEditUser] = useState(null);
//   const [formData, setFormData] = useState({ status: "" });

//   const [searchTerm, setSearchTerm] = useState("");
//   const [searchResult, setSearchResult] = useState([]);
//   const [statusFilter, setStatusFilter] = useState("");

//   // View Orders modal state
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [viewUser, setViewUser] = useState(null);
//   const [viewOrders, setViewOrders] = useState([]);

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const response = await axios.get(`${URL}/allusers`);
//       setUsers(response.data);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };

//   const handleEdit = async (userId) => {
//     try {
//       const response = await axios.get(`${URL}/user/${userId}`);
//       setEditUser(response.data);
//       setFormData({ status: response.data.status });
//       setShowEditModal(true);
//     } catch (error) {
//       console.error("Error fetching user details:", error);
//     }
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setEditUser(null);
//     setFormData({ status: "" });
//   };

//   const handleUpdateUser = async () => {
//     try {
//       await axios.put(`${URL}/user/${editUser.Id}/status`, {
//         status: formData.status,
//       });
//       fetchUsers();
//       setShowEditModal(false);
//       setEditUser(null);
//       setFormData({ status: "" });
//     } catch (error) {
//       console.error("Error updating user status:", error);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSearch = (value) => {
//     setSearchTerm(value);
//     applyFilters(value, statusFilter);
//     setCurrentPage(1); // Reset to the first page after the search
//   };

//   const handleStatusFilter = (e) => {
//     const value = e.target.value;
//     setStatusFilter(value);
//     applyFilters(searchTerm, value);
//     setCurrentPage(1); // Reset to the first page after filter change
//   };

//   const applyFilters = (searchTerm, statusFilter) => {
//     let filteredUsers = [...users];
//     if (searchTerm) {
//       filteredUsers = filteredUsers.filter(
//         (user) =>
//           user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           user.mobile.toString().includes(searchTerm) ||
//           user.Id.toString().includes(searchTerm) // Added search by User ID
//       );
//     }
//     if (statusFilter) {
//       filteredUsers = filteredUsers.filter(
//         (user) => user.status === statusFilter
//       );
//     }
//     setSearchResult(filteredUsers);
//   };

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = (
//     searchTerm || statusFilter ? searchResult : users
//   ).slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(
//     (searchTerm || statusFilter ? searchResult.length : users.length) /
//       itemsPerPage
//   );

//   // Summary counts
//   const TotalCount = users.length;
//   const verifiedCount = users.filter(
//     (user) => user.status === "Verified"
//   ).length;
//   const pendingCount = users.filter((user) => user.status === "Pending").length;
//   const blockedCount = users.filter((user) => user.status === "Blocked").length;

//   // View Orders Handlers
//   const handleViewOrders = async (user) => {
//     try {
//       const resp = await axios.get(
//         `${URL}/user/${user.Id}/orders`
//       );
//       setViewUser(user);
//       setViewOrders(resp.data);
//       setShowViewModal(true);
//     } catch (err) {
//       console.error("Error fetching user orders:", err);
//     }
//   };
//   const handleCloseViewModal = () => {
//     setShowViewModal(false);
//     setViewUser(null);
//     setViewOrders([]);
//   };

//   // Order counts
//   const totalOrders = viewOrders.length;
//   const completedOrders = viewOrders.filter(
//     (o) => o.status === "Completed"
//   ).length;
//   const canceledOrders = viewOrders.filter(
//     (o) => o.status === "Canceled"
//   ).length;
//   const canceledByServitor = viewOrders.filter(
//     (o) => o.status === "Canceled by Servitor"
//   ).length;
//   const deadlineTimeout = viewOrders.filter(
//     (o) => o.status === "Deadline Timeout"
//   ).length;
//   const acceptedOrders = viewOrders.filter(
//     (o) => o.status === "Accepted"
//   ).length;

//   return (
//     <Container fluid className="adminUserdetails-container">
//       <Card className="adminUserdetails-card">
//         <Card.Body>
//           {/* <Card.Title className="adminUserdetails-title">
//             User Details
//           </Card.Title> */}

//           <Card.Header className="adminUserdetails-header">
//             <h4 className="adminUserdetails-title">User Details</h4>
//           </Card.Header>

//           {/* Summary Cards */}
//           <div className="adminUserdetails-summary-cards">
//             <div className="adminUserdetails-summary-card adminUserdetails-verified-card">
//               <div>
//                 <p className="adminUserdetails-detail-text">Total User</p>
//                 <p className="adminUserdetails-count-value">{TotalCount}</p>
//               </div>
//             </div>
//             <div className="adminUserdetails-summary-card adminUserdetails-verified-card">
//               <div>
//                 <p className="adminUserdetails-detail-text">Total Verified</p>
//                 <p className="adminUserdetails-count-value">{verifiedCount}</p>
//               </div>
//             </div>
//             <div className="adminUserdetails-summary-card adminUserdetails-pending-card">
//               <div>
//                 <p className="adminUserdetails-detail-text">Total Pending</p>
//                 <p className="adminUserdetails-count-value">{pendingCount}</p>
//               </div>
//             </div>
//             <div className="adminUserdetails-summary-card adminUserdetails-blocked-card">
//               <div>
//                 <p className="adminUserdetails-detail-text">Total Blocked</p>
//                 <p className="adminUserdetails-count-value">{blockedCount}</p>
//               </div>
//             </div>
//           </div>

//           {/* Filters and Search */}
//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by email, mobile, or User ID"
//                   value={searchTerm}
//                   onChange={(e) => handleSearch(e.target.value)}
//                   className="adminUserdetails-search"
//                 />
//                 <InputGroup.Text>search</InputGroup.Text>
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Select
//                 as="select"
//                 value={statusFilter}
//                 onChange={handleStatusFilter}
//                 className="adminUserdetails-search"
//                 style={{ height: "45px" }}
//               >
//                 <option value="">All Statuses</option>
//                 <option value="Verified">Verified</option>
//                 <option value="Pending">Pending</option>
//                 <option value="Blocked">Blocked</option>
//               </Form.Select>
//             </Col>
//           </Row>

//           {/* Table with Scrollable Wrapper */}
//           <div className="adminUserdetails-table-wrapper">
//             <Table
//               striped
//               bordered
//               hover
//               responsive
//               className="adminUserdetails-table"
//             >
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>First Name</th>
//                   <th>Last Name</th>
//                   <th>User ID</th>
//                   <th>Email</th>
//                   <th>Mobile</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.map((user, index) => (
//                   <tr key={user.Id}>
//                     <td>{index + 1 + indexOfFirstItem}</td>
//                     <td>{user.FirstName}</td>
//                     <td>{user.LastName}</td>
//                     <td>{user.Id}</td>
//                     <td>{user.email}</td>
//                     <td>{user.mobile}</td>
//                     <td>
//                       <span
//                         className={`adminUserdetails-badge-${user.status.toLowerCase()}`}
//                       >
//                         {user.status}
//                       </span>
//                     </td>
//                     <td className="adminUserdetails-action-group">
//                       <Button
//                         variant="outline-info"
//                         size="sm"
//                         className="adminUserdetails-action-btn me-1"
//                         onClick={() => handleViewOrders(user)}
//                       >
//                         <i className="bi bi-eye"></i>
//                       </Button>
//                       <Button
//                         variant="outline-primary"
//                         size="sm"
//                         className="adminUserdetails-action-btn"
//                         onClick={() => handleEdit(user.Id)}
//                       >
//                         <i
//                           className="bi bi-pencil-square"
//                           style={{ color: "blue" }}
//                         ></i>
//                       </Button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>

//           {/* Pagination */}
//           <Pagination className="adminUserdetails-pagination">
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       <Modal
//         show={showEditModal}
//         onHide={handleCloseEditModal}
//         centered
//         className="adminUserdetails-modal"
//       >
//         <Modal.Header closeButton className="adminUserdetails-modal-header">
//           <Modal.Title>Edit User Status</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminUserdetails-modal-body">
//           <Form>
//             <Form.Group className="mb-3" controlId="editStatus">
//               <Form.Label className="adminUserdetails-form-label">
//                 Status
//               </Form.Label>
//               <Form.Control
//                 as="select"
//                 name="status"
//                 value={formData.status}
//                 onChange={handleChange}
//                 className="adminUserdetails-form-control"
//               >
//                 <option value="Verified">Verified</option>
//                 <option value="Pending">Pending</option>
//                 <option value="Blocked">Blocked</option>
//               </Form.Control>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer className="adminUserdetails-modal-footer">
//           <Button
//             variant="secondary"
//             onClick={handleCloseEditModal}
//             className="adminUserdetails-footer-btn adminUserdetails-footer-btn-close"
//           >
//             Close
//           </Button>
//           <Button
//             variant="primary"
//             onClick={handleUpdateUser}
//             className="adminUserdetails-footer-btn adminUserdetails-footer-btn-save"
//           >
//             Update
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* View Orders Modal */}
//       <Modal
//         show={showViewModal}
//         onHide={handleCloseViewModal}
//         size="lg"
//         centered
//         className="adminUserdetails-modal"
//         style={{ marginTop: "20px" }}
//       >
//         <Modal.Header closeButton className="adminUserdetails-modal-header">
//           <Modal.Title>
//             Details of {viewUser?.FirstName} {viewUser?.LastName} ({totalOrders}{" "}
//             Orders)
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminUserdetails-modal-body">
//           {/* User Details Section */}
//           <div className="adminUserdetails-viewmodal-profile">
//             <div className="adminUserdetails-viewmodal-avatar">
//               {viewUser?.FirstName?.charAt(0)}
//               {viewUser?.LastName?.charAt(0)}
//             </div>
//             <div className="adminUserdetails-viewmodal-profile-info">
//               <h3 className="adminUserdetails-viewmodal-name">
//                 {viewUser?.FirstName} {viewUser?.LastName}
//               </h3>
//               <span
//                 className={`adminUserdetails-viewmodal-badge adminUserdetails-viewmodal-badge-${viewUser?.status.toLowerCase()}`}
//               >
//                 {viewUser?.status}
//               </span>
//             </div>
//           </div>

//           <div className="adminUserdetails-viewmodal-details-grid">
//             <div className="adminUserdetails-viewmodal-section">
//               <h4 className="adminUserdetails-viewmodal-section-title">
//                 Details
//               </h4>
//               <div className="adminUserdetails-viewmodal-section-content">
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">
//                     User ID
//                   </span>
//                   <span className="adminUserdetails-viewmodal-value">
//                     {viewUser?.Id}
//                   </span>
//                 </div>
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">
//                     User Email
//                   </span>
//                   <span className="adminUserdetails-viewmodal-value">
//                     {viewUser?.email}
//                   </span>
//                 </div>
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">City</span>
//                   <span className="adminUserdetails-viewmodal-value">
//                     {viewUser?.city}
//                   </span>
//                 </div>
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">
//                     Address
//                   </span>
//                   <span className="adminUserdetails-viewmodal-value">
//                     {viewUser?.Address}
//                   </span>
//                 </div>
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">DOB</span>
//                   <span className="adminUserdetails-viewmodal-value">
//                     {new Date(viewUser?.dob).toLocaleDateString("en-US", {
//                       year: "numeric",
//                       month: "long",
//                       day: "numeric",
//                     })}
//                   </span>
//                 </div>
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">
//                     Gender
//                   </span>
//                   <span className="adminUserdetails-viewmodal-value">
//                     {viewUser?.gender}
//                   </span>
//                 </div>
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">
//                     Joined HelpNao
//                   </span>
//                   <span className="adminUserdetails-viewmodal-value">
//                     {new Date(viewUser?.created_at).toLocaleDateString(
//                       "en-US",
//                       {
//                         year: "numeric",
//                         month: "long",
//                         day: "numeric",
//                       }
//                     )}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Order Counts Section */}
//           <div className="adminUserdetails-viewmodal-full-section">
//             <h4 className="adminUserdetails-viewmodal-section-title">
//               Order Statistics
//             </h4>
//             <div className="adminUserdetails-viewmodal-counts-grid">
//               <div className="adminUserdetails-viewmodal-count-item">
//                 <span className="adminUserdetails-viewmodal-count-label">
//                   Total Orders
//                 </span>
//                 <span className="adminUserdetails-viewmodal-count-value">
//                   {totalOrders}
//                 </span>
//               </div>
//               <div className="adminUserdetails-viewmodal-count-item">
//                 <span className="adminUserdetails-viewmodal-count-label">
//                   Completed
//                 </span>
//                 <span className="adminUserdetails-viewmodal-count-value">
//                   {completedOrders}
//                 </span>
//               </div>
//               <div className="adminUserdetails-viewmodal-count-item">
//                 <span className="adminUserdetails-viewmodal-count-label">
//                   Canceled
//                 </span>
//                 <span className="adminUserdetails-viewmodal-count-value">
//                   {canceledOrders}
//                 </span>
//               </div>
//               <div className="adminUserdetails-viewmodal-count-item">
//                 <span className="adminUserdetails-viewmodal-count-label">
//                   Canceled by Servitor
//                 </span>
//                 <span className="adminUserdetails-viewmodal-count-value">
//                   {canceledByServitor}
//                 </span>
//               </div>
//               <div className="adminUserdetails-viewmodal-count-item">
//                 <span className="adminUserdetails-viewmodal-count-label">
//                   Deadline Timeout
//                 </span>
//                 <span className="adminUserdetails-viewmodal-count-value">
//                   {deadlineTimeout}
//                 </span>
//               </div>
//               <div className="adminUserdetails-viewmodal-count-item">
//                 <span className="adminUserdetails-viewmodal-count-label">
//                   Accepted
//                 </span>
//                 <span className="adminUserdetails-viewmodal-count-value">
//                   {acceptedOrders}
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Orders List */}
//           <div className="adminUserdetails-viewmodal-full-section">
//             <h4 className="adminUserdetails-viewmodal-section-title">
//               Order List
//             </h4>
//             {viewOrders.length === 0 ? (
//               <p className="text-center text-muted">No orders found.</p>
//             ) : (
//               <Table striped hover size="sm" style={{ fontSize: "14px" }}>
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Order #</th>
//                     <th>Service</th>
//                     <th>Status</th>
//                     <th>Price</th>
//                     <th>Date</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {viewOrders.map((o, i) => (
//                     <tr key={o.order_number || i}>
//                       <td>{i + 1}</td>
//                       <td>{o.order_number}</td>
//                       <td>{o.Service?.services_name || o.service_name}</td>
//                       <td>{o.status}</td>
//                       <td>{o.price}</td>
//                       <td>
//                         {new Date(o.created_at).toLocaleDateString()} <br />
//                         {new Date(o.created_at).toLocaleTimeString()}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             )}
//           </div>
//         </Modal.Body>
//         <Modal.Footer className="adminUserdetails-modal-footer">
//           <Button
//             variant="secondary"
//             onClick={handleCloseViewModal}
//             className="adminUserdetails-footer-btn adminUserdetails-footer-btn-close"
//           >
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// };

// export default UserDetails;

// ***** Update with pagination from backend and search ***** //
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Button,
//   Card,
//   Container,
//   Form,
//   Table,
//   Modal,
//   InputGroup,
//   Row,
//   Col,
//   Pagination,
// } from "react-bootstrap";
// import "./UserDetails.css";
// import { URL } from "../../../config";

// const UserDetails = () => {
//   // Edit modal state
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [editUser, setEditUser] = useState(null);
//   const [formData, setFormData] = useState({ status: "" });

//   // Users table state
//   const [users, setUsers] = useState([]);
//   const [meta, setMeta] = useState({
//     page: 1,
//     limit: 10,
//     totalPages: 1,
//     total: 0,
//     sortBy: "created_at",
//     sortDir: "DESC",
//   });
//   const [summary, setSummary] = useState({
//     total: 0,
//     verified: 0,
//     pending: 0,
//     blocked: 0,
//   });

//   // Filters
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");

//   // View Orders modal state
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [viewUser, setViewUser] = useState(null);
//   const [viewOrders, setViewOrders] = useState([]);

//   // Client-facing page size (server honors this)
//   const itemsPerPage = 10;

//   // Current page (drives server paging)
//   const [currentPage, setCurrentPage] = useState(1);

//   // Fetch users from backend with server-driven pagination/filtering
//   const fetchUsers = async () => {
//     try {
//       const params = new URLSearchParams({
//         page: currentPage,
//         limit: itemsPerPage,
//         search: searchTerm || "",
//         status: statusFilter || "",
//         sortBy: "created_at",
//         sortDir: "DESC",
//       }).toString();

//       const response = await axios.get(`${URL}/allusers?${params}`);
//       const { data = [], meta: m = {}, summary: s = {} } = response.data || {};
//       setUsers(data);
//       setMeta({
//         page: m.page || 1,
//         limit: m.limit || itemsPerPage,
//         totalPages: Math.max(1, m.totalPages || 1),
//         total: m.total || 0,
//         sortBy: m.sortBy || "created_at",
//         sortDir: m.sortDir || "DESC",
//       });
//       setSummary({
//         total: s.total || 0,
//         verified: s.verified || 0,
//         pending: s.pending || 0,
//         blocked: s.blocked || 0,
//       });
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };

//   // Load on initial mount + whenever filters/page change
//   useEffect(() => {
//     fetchUsers();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [currentPage, searchTerm, statusFilter]);

//   // ===== Edit handlers =====
//   const handleEdit = async (userId) => {
//     try {
//       const response = await axios.get(`${URL}/user/${userId}`);
//       setEditUser(response.data);
//       setFormData({ status: response.data.status });
//       setShowEditModal(true);
//     } catch (error) {
//       console.error("Error fetching user details:", error);
//     }
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setEditUser(null);
//     setFormData({ status: "" });
//   };

//   const handleUpdateUser = async () => {
//     try {
//       await axios.put(`${URL}/user/${editUser.Id}/status`, {
//         status: formData.status,
//       });
//       // Refresh list (keep current page/filters)
//       fetchUsers();
//       setShowEditModal(false);
//       setEditUser(null);
//       setFormData({ status: "" });
//     } catch (error) {
//       console.error("Error updating user status:", error);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   // ===== Filters & pagination =====
//   const handleSearch = (value) => {
//     setSearchTerm(value);
//     setCurrentPage(1); // reset page on new search
//   };

//   const handleStatusFilter = (e) => {
//     const value = e.target.value;
//     setStatusFilter(value);
//     setCurrentPage(1); // reset page on new filter
//   };

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Derived for numbering in table
//   const indexOfFirstItem = (meta.page - 1) * meta.limit;

//   // Summary counts (from backend)
//   const TotalCount = summary.total;
//   const verifiedCount = summary.verified;
//   const pendingCount = summary.pending;
//   const blockedCount = summary.blocked;

//   // ===== View Orders Handlers =====
//   const handleViewOrders = async (user) => {
//     try {
//       const resp = await axios.get(`${URL}/user/${user.Id}/orders`);
//       setViewUser(user);
//       setViewOrders(resp.data || []);
//       setShowViewModal(true);
//     } catch (err) {
//       console.error("Error fetching user orders:", err);
//     }
//   };

//   const handleCloseViewModal = () => {
//     setShowViewModal(false);
//     setViewUser(null);
//     setViewOrders([]);
//   };

//   // Order counts (align with backend status strings)
//   const totalOrders = viewOrders.length;
//   const completedOrders = viewOrders.filter((o) => o.status === "Completed").length;
//   const canceledOrders = viewOrders.filter((o) => o.status === "Cancelled").length;
//   const canceledByServitor = viewOrders.filter((o) => o.status === "Cancelled by Servitor").length;
//   const deadlineTimeout = viewOrders.filter((o) => o.status === "Deadline-Timeout").length;
//   const acceptedOrders = viewOrders.filter((o) => o.status === "Accepted").length;

//   const totalPages = meta.totalPages || 1;

//   return (
//     <Container fluid className="adminUserdetails-container">
//       <Card className="adminUserdetails-card">
//         <Card.Body>
//           <Card.Header className="adminUserdetails-header">
//             <h4 className="adminUserdetails-title">User Details</h4>
//           </Card.Header>

//           {/* Summary Cards */}
//           <div className="adminUserdetails-summary-cards">
//             <div className="adminUserdetails-summary-card adminUserdetails-verified-card">
//               <div>
//                 <p className="adminUserdetails-detail-text">Total User</p>
//                 <p className="adminUserdetails-count-value">{TotalCount}</p>
//               </div>
//             </div>
//             <div className="adminUserdetails-summary-card adminUserdetails-verified-card">
//               <div>
//                 <p className="adminUserdetails-detail-text">Total Verified</p>
//                 <p className="adminUserdetails-count-value">{verifiedCount}</p>
//               </div>
//             </div>
//             <div className="adminUserdetails-summary-card adminUserdetails-pending-card">
//               <div>
//                 <p className="adminUserdetails-detail-text">Total Pending</p>
//                 <p className="adminUserdetails-count-value">{pendingCount}</p>
//               </div>
//             </div>
//             <div className="adminUserdetails-summary-card adminUserdetails-blocked-card">
//               <div>
//                 <p className="adminUserdetails-detail-text">Total Blocked</p>
//                 <p className="adminUserdetails-count-value">{blockedCount}</p>
//               </div>
//             </div>
//           </div>

//           {/* Filters and Search */}
//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by email, mobile, or User ID"
//                   value={searchTerm}
//                   onChange={(e) => handleSearch(e.target.value)}
//                   className="adminUserdetails-search"
//                 />
//                 <InputGroup.Text>search</InputGroup.Text>
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Select
//                 as="select"
//                 value={statusFilter}
//                 onChange={handleStatusFilter}
//                 className="adminUserdetails-search"
//                 style={{ height: "45px" }}
//               >
//                 <option value="">All Statuses</option>
//                 <option value="Verified">Verified</option>
//                 <option value="Pending">Pending</option>
//                 <option value="Blocked">Blocked</option>
//               </Form.Select>
//             </Col>
//           </Row>

//           {/* Table with Scrollable Wrapper */}
//           <div className="adminUserdetails-table-wrapper">
//             <Table
//               striped
//               bordered
//               hover
//               responsive
//               className="adminUserdetails-table"
//             >
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>First Name</th>
//                   <th>Last Name</th>
//                   <th>User ID</th>
//                   <th>Email</th>
//                   <th>Mobile</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {users.length === 0 ? (
//                   <tr>
//                     <td colSpan={8} className="text-center text-muted">
//                       No users found.
//                     </td>
//                   </tr>
//                 ) : (
//                   users.map((user, index) => (
//                     <tr key={user.Id}>
//                       <td>{index + 1 + indexOfFirstItem}</td>
//                       <td>{user.FirstName}</td>
//                       <td>{user.LastName}</td>
//                       <td>{user.Id}</td>
//                       <td>{user.email}</td>
//                       <td>{user.mobile}</td>
//                       <td>
//                         <span
//                           className={`adminUserdetails-badge-${String(
//                             user.status || ""
//                           ).toLowerCase()}`}
//                         >
//                           {user.status}
//                         </span>
//                       </td>
//                       <td className="adminUserdetails-action-group">
//                         <Button
//                           variant="outline-info"
//                           size="sm"
//                           className="adminUserdetails-action-btn me-1"
//                           onClick={() => handleViewOrders(user)}
//                         >
//                           <i className="bi bi-eye"></i>
//                         </Button>
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           className="adminUserdetails-action-btn"
//                           onClick={() => handleEdit(user.Id)}
//                         >
//                           <i
//                             className="bi bi-pencil-square"
//                             style={{ color: "blue" }}
//                           ></i>
//                         </Button>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </Table>
//           </div>

//           {/* Pagination (server-driven) */}
//           <Pagination className="adminUserdetails-pagination">
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
//               disabled={currentPage === 1}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>

//       {/* Edit User Modal */}
//       <Modal
//         show={showEditModal}
//         onHide={handleCloseEditModal}
//         centered
//         className="adminUserdetails-modal"
//       >
//         <Modal.Header closeButton className="adminUserdetails-modal-header">
//           <Modal.Title>Edit User Status</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminUserdetails-modal-body">
//           <Form>
//             <Form.Group className="mb-3" controlId="editStatus">
//               <Form.Label className="adminUserdetails-form-label">
//                 Status
//               </Form.Label>
//               <Form.Control
//                 as="select"
//                 name="status"
//                 value={formData.status}
//                 onChange={handleChange}
//                 className="adminUserdetails-form-control"
//               >
//                 <option value="Verified">Verified</option>
//                 <option value="Pending">Pending</option>
//                 <option value="Blocked">Blocked</option>
//               </Form.Control>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer className="adminUserdetails-modal-footer">
//           <Button
//             variant="secondary"
//             onClick={handleCloseEditModal}
//             className="adminUserdetails-footer-btn adminUserdetails-footer-btn-close"
//           >
//             Close
//           </Button>
//           <Button
//             variant="primary"
//             onClick={handleUpdateUser}
//             className="adminUserdetails-footer-btn adminUserdetails-footer-btn-save"
//           >
//             Update
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* View Orders Modal */}
//       <Modal
//         show={showViewModal}
//         onHide={handleCloseViewModal}
//         size="lg"
//         centered
//         className="adminUserdetails-modal"
//         style={{ marginTop: "20px" }}
//       >
//         <Modal.Header closeButton className="adminUserdetails-modal-header">
//           <Modal.Title>
//             Details of {viewUser?.FirstName} {viewUser?.LastName} ({totalOrders} Orders)
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="adminUserdetails-modal-body">
//           {/* User Details Section */}
//           <div className="adminUserdetails-viewmodal-profile">
//             <div className="adminUserdetails-viewmodal-avatar">
//               {viewUser?.FirstName?.charAt(0)}
//               {viewUser?.LastName?.charAt(0)}
//             </div>
//             <div className="adminUserdetails-viewmodal-profile-info">
//               <h3 className="adminUserdetails-viewmodal-name">
//                 {viewUser?.FirstName} {viewUser?.LastName}
//               </h3>
//               <span
//                 className={`adminUserdetails-viewmodal-badge adminUserdetails-viewmodal-badge-${String(
//                   viewUser?.status || ""
//                 ).toLowerCase()}`}
//               >
//                 {viewUser?.status}
//               </span>
//             </div>
//           </div>

//           <div className="adminUserdetails-viewmodal-details-grid">
//             <div className="adminUserdetails-viewmodal-section">
//               <h4 className="adminUserdetails-viewmodal-section-title">
//                 Details
//               </h4>
//               <div className="adminUserdetails-viewmodal-section-content">
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">User ID</span>
//                   <span className="adminUserdetails-viewmodal-value">{viewUser?.Id}</span>
//                 </div>
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">User Email</span>
//                   <span className="adminUserdetails-viewmodal-value">{viewUser?.email}</span>
//                 </div>
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">City</span>
//                   <span className="adminUserdetails-viewmodal-value">{viewUser?.city}</span>
//                 </div>
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">Address</span>
//                   <span className="adminUserdetails-viewmodal-value">{viewUser?.Address}</span>
//                 </div>
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">DOB</span>
//                   <span className="adminUserdetails-viewmodal-value">
//                     {viewUser?.dob
//                       ? new Date(viewUser?.dob).toLocaleDateString("en-US", {
//                           year: "numeric",
//                           month: "long",
//                           day: "numeric",
//                         })
//                       : ""}
//                   </span>
//                 </div>
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">Gender</span>
//                   <span className="adminUserdetails-viewmodal-value">{viewUser?.gender}</span>
//                 </div>
//                 <div className="adminUserdetails-viewmodal-detail-item">
//                   <span className="adminUserdetails-viewmodal-label">Joined HelpNao</span>
//                   <span className="adminUserdetails-viewmodal-value">
//                     {viewUser?.created_at
//                       ? new Date(viewUser?.created_at).toLocaleDateString("en-US", {
//                           year: "numeric",
//                           month: "long",
//                           day: "numeric",
//                         })
//                       : ""}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Order Counts Section */}
//           <div className="adminUserdetails-viewmodal-full-section">
//             <h4 className="adminUserdetails-viewmodal-section-title">
//               Order Statistics
//             </h4>
//             <div className="adminUserdetails-viewmodal-counts-grid">
//               <div className="adminUserdetails-viewmodal-count-item">
//                 <span className="adminUserdetails-viewmodal-count-label">Total Orders</span>
//                 <span className="adminUserdetails-viewmodal-count-value">{totalOrders}</span>
//               </div>
//               <div className="adminUserdetails-viewmodal-count-item">
//                 <span className="adminUserdetails-viewmodal-count-label">Completed</span>
//                 <span className="adminUserdetails-viewmodal-count-value">{completedOrders}</span>
//               </div>
//               <div className="adminUserdetails-viewmodal-count-item">
//                 <span className="adminUserdetails-viewmodal-count-label">Cancelled</span>
//                 <span className="adminUserdetails-viewmodal-count-value">{canceledOrders}</span>
//               </div>
//               <div className="adminUserdetails-viewmodal-count-item">
//                 <span className="adminUserdetails-viewmodal-count-label">Cancelled by Servitor</span>
//                 <span className="adminUserdetails-viewmodal-count-value">{canceledByServitor}</span>
//               </div>
//               <div className="adminUserdetails-viewmodal-count-item">
//                 <span className="adminUserdetails-viewmodal-count-label">Deadline Timeout</span>
//                 <span className="adminUserdetails-viewmodal-count-value">{deadlineTimeout}</span>
//               </div>
//               <div className="adminUserdetails-viewmodal-count-item">
//                 <span className="adminUserdetails-viewmodal-count-label">Accepted</span>
//                 <span className="adminUserdetails-viewmodal-count-value">{acceptedOrders}</span>
//               </div>
//             </div>
//           </div>

//           {/* Orders List */}
//           <div className="adminUserdetails-viewmodal-full-section">
//             <h4 className="adminUserdetails-viewmodal-section-title">Order List</h4>
//             {viewOrders.length === 0 ? (
//               <p className="text-center text-muted">No orders found.</p>
//             ) : (
//               <Table striped hover size="sm" style={{ fontSize: "14px" }}>
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Order #</th>
//                     <th>Service</th>
//                     <th>Status</th>
//                     <th>Price</th>
//                     <th>Date</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {viewOrders.map((o, i) => (
//                     <tr key={o.order_number || i}>
//                       <td>{i + 1}</td>
//                       <td>{o.order_number}</td>
//                       <td>{o.Service?.services_name || o.service_name}</td>
//                       <td>{o.status}</td>
//                       <td>{o.price}</td>
//                       <td>
//                         {o.created_at ? new Date(o.created_at).toLocaleDateString() : ""} <br />
//                         {o.created_at ? new Date(o.created_at).toLocaleTimeString() : ""}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             )}
//           </div>
//         </Modal.Body>
//         <Modal.Footer className="adminUserdetails-modal-footer">
//           <Button
//             variant="secondary"
//             onClick={handleCloseViewModal}
//             className="adminUserdetails-footer-btn adminUserdetails-footer-btn-close"
//           >
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// };

// export default UserDetails;

// ***** Upper code is okay, Just updated for Auth protected (2-Dec-2025) ***** //
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  Card,
  Container,
  Form,
  Table,
  Modal,
  InputGroup,
  Row,
  Col,
  Pagination,
  Image,
  Spinner,
  Alert,
} from "react-bootstrap";
import { FaTrash } from "react-icons/fa";
import "./UserDetails.css";
import { URL } from "../../../config";

/* ===========================
   ADMIN AUTH HELPER
   =========================== */
const getAdminHeaders = () => {
  const adminToken = localStorage.getItem("adminToken");
  return adminToken ? { Authorization: `Bearer ${adminToken}` } : {};
};
/* =========================== */


// ===== FILE URL HELPERS (MUST be above component) =====
const fileUrl = (p) => {
  if (!p) return "";
  if (/^https?:\/\//i.test(p)) return p;
  const clean = p.startsWith("/") ? p : `/${p}`;
  return `${URL}${clean.startsWith("/uploads/") ? clean : `/uploads${clean}`}`;
};


const getAdminRole = () => {
  const token = localStorage.getItem("adminToken");
  if (!token) return null;

  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    const payload = JSON.parse(jsonPayload);

    // your backend token might store: role (string) OR adminRole OR roleNumber
    // Your adminAuth checks payload.role === 'admin', so numeric role is likely payload.adminRole OR payload.roleLevel OR admin.role
    // We'll return the best available:
    const roleNum = Number(
  payload.adminRole ??
  payload.roleNumber ??
  payload.role_level ??
  payload.roleLevel ??
  payload.dbRole ??
  payload.roleId ??
  payload.admin_role ??
  payload?.admin?.role ??          
  payload?.admin?.adminRole ??     
  payload?.admin?.roleId           
);

    return Number.isFinite(roleNum) ? roleNum : null;
  } catch (e) {
    return null;
  }
};


const UserDetails = () => {
  // Edit modal state
  const [showEditModal, setShowEditModal] = useState(false);
  const [editUser, setEditUser] = useState(null);
  // const [formData, setFormData] = useState({ status: "" });
  const [formData, setFormData] = useState({
    status: "",
    city: "",
    area: "",
    Address: "",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [showImageModal, setShowImageModal] = useState(false);
  const [imageSrc, setImageSrc] = useState("");


  // Users table state
  const [users, setUsers] = useState([]);
  const [meta, setMeta] = useState({
    page: 1,
    limit: 10,
    totalPages: 1,
    total: 0,
    sortBy: "created_at",
    sortDir: "DESC",
  });
  const [summary, setSummary] = useState({
    total: 0,
    verified: 0,
    pending: 0,
    blocked: 0,
  });

  // Filters
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  // View Orders modal state
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewUser, setViewUser] = useState(null);
  const [viewOrders, setViewOrders] = useState([]);

  // Active locations (dropdown data)
  const [divisions, setDivisions] = useState([]); // cities
  const [areas, setAreas] = useState([]); // areas for selected city

  // Selected dropdown IDs (we store IDs for dropdown, but save names to DB)
  const [selectedDivisionId, setSelectedDivisionId] = useState("");
  const [selectedAreaId, setSelectedAreaId] = useState("");

  // Client-facing page size (server honors this)
  const itemsPerPage = 10;

  // Current page (drives server paging)
  const [currentPage, setCurrentPage] = useState(1);


  const [adminRole, setAdminRole] = useState(null);

  useEffect(() => {
    setAdminRole(getAdminRole());
  }, []);

  const canDeleteUser = Number(adminRole) === 1 || Number(adminRole) === 2;

  // Fetch users from backend with server-driven pagination/filtering
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: currentPage,
        limit: itemsPerPage,
        search: searchTerm || "",
        status: statusFilter || "",
        sortBy: "created_at",
        sortDir: "DESC",
      }).toString();

      const response = await axios.get(`${URL}/allusers?${params}`, {
        headers: getAdminHeaders(),
      });

      const { data = [], meta: m = {}, summary: s = {} } = response.data || {};
      setUsers(data);
      setMeta({
        page: m.page || 1,
        limit: m.limit || itemsPerPage,
        totalPages: Math.max(1, m.totalPages || 1),
        total: m.total || 0,
        sortBy: m.sortBy || "created_at",
        sortDir: m.sortDir || "DESC",
      });
      setSummary({
        total: s.total || 0,
        verified: s.verified || 0,
        pending: s.pending || 0,
        blocked: s.blocked || 0,
      });

      setErrorMessage("");
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
      setErrorMessage(error?.response?.data?.error || "Failed to fetch users.");
    } finally {
      setLoading(false);
    }
  };

  // Load on initial mount + whenever filters/page change
  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, searchTerm, statusFilter]);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(
          `${URL}/locations/divisions?countryCode=BD`,
        );
        setDivisions(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        console.error("Failed to load divisions:", e);
        setDivisions([]);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (!selectedDivisionId) {
        setAreas([]);
        setSelectedAreaId("");
        return;
      }
      try {
        const res = await axios.get(
          `${URL}/locations/areas?divisionId=${selectedDivisionId}`,
        );
        setAreas(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        console.error("Failed to load areas:", e);
        setAreas([]);
        setSelectedAreaId("");
      }
    })();
  }, [selectedDivisionId]);

  const handleImageClick = (src) => {
    setImageSrc(src);
    setShowImageModal(true);
  };

  const handleDeleteUser = async (userId) => {
    if (!canDeleteUser ) {
      setErrorMessage("Only Super Admin can delete users.");
      return;
    }
    if (!window.confirm("Are you sure you want to delete this user?")) return;

    try {
      await axios.delete(`${URL}/admin/users/${userId}`, {
        headers: getAdminHeaders(),
      });

      setErrorMessage("User deleted successfully.");
      // refresh list
      fetchUsers();
    } catch (e) {
      const msg = e?.response?.data?.error || "Failed to delete user.";
      setErrorMessage(msg);
    }
  };

  // ===== Edit handlers =====
  // const handleEdit = async (userId) => {
  //   try {
  //     const response = await axios.get(`${URL}/user/${userId}`, {
  //       headers: getAdminHeaders(),
  //     });
  //     setEditUser(response.data);
  //     // setFormData({ status: response.data.status });
  //     setFormData({
  //       status: response.data.status || "",
  //       city: response.data.city || "",
  //       area: response.data.area || "",
  //       Address: response.data.Address || "",
  //     });

  //     setShowEditModal(true);
  //   } catch (error) {
  //     console.error("Error fetching user details:", error);
  //   }
  // };

  const handleEdit = async (userId) => {
    try {
      const response = await axios.get(`${URL}/user/${userId}`, {
        headers: getAdminHeaders(),
      });

      const u = response.data;
      setEditUser(u);

      setFormData({
        status: u.status || "",
        city: u.city || "",
        area: u.area || "",
        Address: u.Address || "",
      });

      setShowEditModal(true);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  useEffect(() => {
    if (!showEditModal) return;
    if (!divisions.length) return;

    const matchedDiv = divisions.find(
      (d) =>
        String(d.name).toLowerCase() ===
        String(formData.city || "").toLowerCase(),
    );

    const divId = matchedDiv ? String(matchedDiv.Id) : "";
    setSelectedDivisionId(divId);
  }, [showEditModal, divisions, formData.city]);

  useEffect(() => {
    if (!showEditModal) return;
    if (!areas.length) return;

    const matchedArea = areas.find(
      (a) =>
        String(a.name).toLowerCase() ===
        String(formData.area || "").toLowerCase(),
    );

    setSelectedAreaId(matchedArea ? String(matchedArea.Id) : "");
  }, [showEditModal, areas, formData.area]);

  const handleDivisionChange = (e) => {
    const id = e.target.value;
    setSelectedDivisionId(id);
    setSelectedAreaId("");
    setAreas([]);

    const div = divisions.find((d) => String(d.Id) === String(id));
    const cityName = div?.name || "";

    setFormData((prev) => ({
      ...prev,
      city: cityName,
      area: "", // reset area if city changes
    }));
  };

  const handleAreaChange = (e) => {
    const id = e.target.value;
    setSelectedAreaId(id);

    const ar = areas.find((a) => String(a.Id) === String(id));
    const areaName = ar?.name || "";

    setFormData((prev) => ({
      ...prev,
      area: areaName,
    }));
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditUser(null);
    setFormData({ status: "", city: "", area: "", Address: "" });

    setSelectedDivisionId("");
    setSelectedAreaId("");
    setAreas([]);
  };

  const handleUpdateUser = async () => {
    try {
      await axios.put(
        `${URL}/user/${editUser.Id}/status`,
        {
          status: formData.status,
          city: formData.city,
          area: formData.area,
          Address: formData.Address,
        },

        { headers: getAdminHeaders() },
      );
      // Refresh list (keep current page/filters)
      fetchUsers();
      setShowEditModal(false);
      setEditUser(null);
      // setFormData({ status: "" });
      setFormData({ status: "", city: "", area: "", Address: "" });
      setSelectedDivisionId("");
      setSelectedAreaId("");
      setAreas([]);
    } catch (error) {
      console.error("Error updating user status:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // ===== Filters & pagination =====
  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1); // reset page on new search
  };

  const handleStatusFilter = (e) => {
    const value = e.target.value;
    setStatusFilter(value);
    setCurrentPage(1); // reset page on new filter
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Derived for numbering in table
  const indexOfFirstItem = (meta.page - 1) * meta.limit;

  // Summary counts (from backend)
  const TotalCount = summary.total;
  const verifiedCount = summary.verified;
  const pendingCount = summary.pending;
  const blockedCount = summary.blocked;

  // ===== View Orders Handlers =====
  const handleViewOrders = async (user) => {
    try {
      const resp = await axios.get(`${URL}/user/${user.Id}/orders`, {
        headers: getAdminHeaders(),
      });
      setViewUser(user);
      setViewOrders(resp.data || []);
      setShowViewModal(true);
    } catch (err) {
      console.error("Error fetching user orders:", err);
    }
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setViewUser(null);
    setViewOrders([]);
  };

  // Order counts (align with backend status strings)
  const totalOrders = viewOrders.length;
  const completedOrders = viewOrders.filter(
    (o) => o.status === "Completed",
  ).length;
  const canceledOrders = viewOrders.filter(
    (o) => o.status === "Cancelled",
  ).length;
  const canceledByServitor = viewOrders.filter(
    (o) => o.status === "Cancelled by Servitor",
  ).length;
  const deadlineTimeout = viewOrders.filter(
    (o) => o.status === "Deadline-Timeout",
  ).length;
  const acceptedOrders = viewOrders.filter(
    (o) => o.status === "Accepted",
  ).length;

  const totalPages = meta.totalPages || 1;

  return (
    <Container fluid className="adminUserdetails-container">
      <Card className="adminUserdetails-card">
        <Card.Body>
          <Card.Header className="adminUserdetails-header">
            <h4 className="adminUserdetails-title">User Details</h4>
          </Card.Header>

          {/* Summary Cards */}
          <div className="adminUserdetails-summary-cards">
            <div className="adminUserdetails-summary-card adminUserdetails-verified-card">
              <div>
                <p className="adminUserdetails-detail-text">Total User</p>
                <p className="adminUserdetails-count-value">{TotalCount}</p>
              </div>
            </div>
            <div className="adminUserdetails-summary-card adminUserdetails-verified-card">
              <div>
                <p className="adminUserdetails-detail-text">Total Verified</p>
                <p className="adminUserdetails-count-value">{verifiedCount}</p>
              </div>
            </div>
            <div className="adminUserdetails-summary-card adminUserdetails-pending-card">
              <div>
                <p className="adminUserdetails-detail-text">Total Pending</p>
                <p className="adminUserdetails-count-value">{pendingCount}</p>
              </div>
            </div>
            <div className="adminUserdetails-summary-card adminUserdetails-blocked-card">
              <div>
                <p className="adminUserdetails-detail-text">Total Blocked</p>
                <p className="adminUserdetails-count-value">{blockedCount}</p>
              </div>
            </div>
          </div>

          {/* Filters and Search */}
          <Row className="mb-3">
            <Col md={8}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search by email, mobile, or User ID"
                  value={searchTerm}
                  onChange={(e) => handleSearch(e.target.value)}
                  className="adminUserdetails-search"
                />
                <InputGroup.Text>search</InputGroup.Text>
              </InputGroup>
            </Col>
            <Col md={4}>
              <Form.Select
                as="select"
                value={statusFilter}
                onChange={handleStatusFilter}
                className="adminUserdetails-search"
                style={{ height: "45px" }}
              >
                <option value="">All Statuses</option>
                <option value="Verified">Verified</option>
                <option value="Pending">Pending</option>
                <option value="Blocked">Blocked</option>
              </Form.Select>
            </Col>
          </Row>

          {/* Table with Scrollable Wrapper */}
          <div className="adminUserdetails-table-wrapper">
            <Table
              striped
              bordered
              hover
              responsive
              className="adminUserdetails-table"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>User ID</th>
                  {/* <th>Email</th> */}
                  <th>Mobile</th>
                  <th>Image</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={8} className="text-center">
                      <Spinner animation="border" size="sm" />
                    </td>
                  </tr>
                ) : users.length === 0 ? (
                  <tr>
                    <td colSpan={8} className="text-center text-muted">
                      No users found.
                    </td>
                  </tr>
                ) : (
                  users.map((user, index) => (
                    <tr key={user.Id}>
                      <td>{index + 1 + indexOfFirstItem}</td>
                      <td>{user.FirstName}</td>
                      <td>{user.LastName}</td>
                      <td>{user.Id}</td>
                      {/* <td>{user.email}</td> */}
                      <td>{user.mobile}</td>
                      <td>
                        {user.image ? (
                          <Image
                            src={fileUrl(user.image)}
                            alt={user.FirstName}
                            rounded
                            width="40"
                            height="40"
                            style={{ cursor: "pointer", objectFit: "cover" }}
                            onClick={() =>
                              handleImageClick(fileUrl(user.image))
                            }
                          />
                        ) : (
                          <span className="text-muted">N/A</span>
                        )}
                      </td>

                      <td>
                        <span
                          className={`adminUserdetails-badge-${String(
                            user.status || "",
                          ).toLowerCase()}`}
                        >
                          {user.status}
                        </span>
                      </td>
                      <td className="adminUserdetails-action-group">
                        <Button
                          variant="outline-info"
                          size="sm"
                          className="adminUserdetails-action-btn me-1"
                          onClick={() => handleViewOrders(user)}
                        >
                          <i className="bi bi-eye"></i>
                        </Button>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="adminUserdetails-action-btn"
                          onClick={() => handleEdit(user.Id)}
                        >
                          <i
                            className="bi bi-pencil-square"
                            style={{ color: "blue" }}
                          ></i>
                        </Button>

                        {canDeleteUser && (
                          <Button
                            variant="outline-danger"
                            size="sm"
                            className="adminUserdetails-action-btn ms-1"
                            onClick={() => handleDeleteUser(user.Id)}
                            title="Delete user (Super Admin only)"
                          >
                            <FaTrash size={14} />
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>

          {/* Pagination (server-driven) */}
          <Pagination className="adminUserdetails-pagination">
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
            />
            {[...Array(totalPages)].map((_, index) => (
              <Pagination.Item
                key={index + 1}
                active={index + 1 === currentPage}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() =>
                handlePageChange(Math.min(totalPages, currentPage + 1))
              }
              disabled={currentPage === totalPages}
            />
            <Pagination.Last
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        </Card.Body>
      </Card>

      {/* Edit User Modal */}
      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        centered
        className="adminUserdetails-modal"
      >
        <Modal.Header closeButton className="adminUserdetails-modal-header">
          <Modal.Title>Edit User Status</Modal.Title>
        </Modal.Header>
        <Modal.Body className="adminUserdetails-modal-body">
          <Form>
            <Form.Group className="mb-3" controlId="editStatus">
              <Form.Label className="adminUserdetails-form-label">
                Status
              </Form.Label>

              <InputGroup>
                <Form.Select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  className={`adminUserdetails-form-control adminUserdetails-select ${
                    formData.status ? "has-value" : ""
                  } adminUserdetails-status-${String(formData.status || "").toLowerCase()}`}
                >
                  <option value="">Select Status</option>
                  <option value="Verified">Verified</option>
                  <option value="Pending">Pending</option>
                  <option value="Blocked">Blocked</option>
                </Form.Select>

                <InputGroup.Text className="adminUserdetails-select-icon">
                  <i className="bi bi-chevron-down" />
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-3" controlId="editCity">
              <Form.Label className="adminUserdetails-form-label">
                City
              </Form.Label>

              <InputGroup>
                <Form.Select
                  value={selectedDivisionId}
                  onChange={handleDivisionChange}
                  className={`adminUserdetails-form-control adminUserdetails-select ${selectedDivisionId ? "has-value" : ""}`}
                >
                  <option value="">Select City</option>
                  {divisions.map((d) => (
                    <option key={d.Id} value={d.Id}>
                      {d.name}
                    </option>
                  ))}
                </Form.Select>
                <InputGroup.Text className="adminUserdetails-select-icon">
                  <i className="bi bi-chevron-down" />
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-3" controlId="editArea">
              <Form.Label className="adminUserdetails-form-label">
                Area
              </Form.Label>

              <InputGroup>
                <Form.Select
                  value={selectedAreaId}
                  onChange={handleAreaChange}
                  disabled={!selectedDivisionId}
                  className={`adminUserdetails-form-control adminUserdetails-select ${selectedAreaId ? "has-value" : ""}`}
                >
                  <option value="">
                    {selectedDivisionId ? "Select Area" : "Select City first"}
                  </option>
                  {areas.map((a) => (
                    <option key={a.Id} value={a.Id}>
                      {a.name}
                    </option>
                  ))}
                </Form.Select>
                <InputGroup.Text className="adminUserdetails-select-icon">
                  <i className="bi bi-chevron-down" />
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-3" controlId="editAddress">
              <Form.Label className="adminUserdetails-form-label">
                Address
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="Address"
                value={formData.Address}
                onChange={handleChange}
                className="adminUserdetails-form-control"
                placeholder="Enter full address"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="adminUserdetails-modal-footer">
          <Button
            variant="secondary"
            onClick={handleCloseEditModal}
            className="adminUserdetails-footer-btn adminUserdetails-footer-btn-close"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleUpdateUser}
            className="adminUserdetails-footer-btn adminUserdetails-footer-btn-save"
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      {/* View Orders Modal */}
      <Modal
        show={showViewModal}
        onHide={handleCloseViewModal}
        size="lg"
        centered
        className="adminUserdetails-modal"
        style={{ marginTop: "20px" }}
      >
        <Modal.Header closeButton className="adminUserdetails-modal-header">
          <Modal.Title>
            Details of {viewUser?.FirstName} {viewUser?.LastName} ({totalOrders}{" "}
            Orders)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="adminUserdetails-modal-body">
          {/* User Details Section */}
          <div className="adminUserdetails-viewmodal-profile">
            <div className="adminUserdetails-viewmodal-avatar">
              {viewUser?.FirstName?.charAt(0)}
              {viewUser?.LastName?.charAt(0)}
            </div>
            <div className="adminUserdetails-viewmodal-profile-info">
              <h3 className="adminUserdetails-viewmodal-name">
                {viewUser?.FirstName} {viewUser?.LastName}
              </h3>
              <span
                className={`adminUserdetails-viewmodal-badge adminUserdetails-viewmodal-badge-${String(
                  viewUser?.status || "",
                ).toLowerCase()}`}
              >
                {viewUser?.status}
              </span>
            </div>
          </div>

          <div className="adminUserdetails-viewmodal-details-grid">
            <div className="adminUserdetails-viewmodal-section">
              <h4 className="adminUserdetails-viewmodal-section-title">
                Details
              </h4>
              <div className="adminUserdetails-viewmodal-section-content">
                <div className="adminUserdetails-viewmodal-detail-item">
                  <span className="adminUserdetails-viewmodal-label">
                    User ID
                  </span>
                  <span className="adminUserdetails-viewmodal-value">
                    {viewUser?.Id}
                  </span>
                </div>
                <div className="adminUserdetails-viewmodal-detail-item">
                  <span className="adminUserdetails-viewmodal-label">
                    User Email
                  </span>
                  <span className="adminUserdetails-viewmodal-value">
                    {viewUser?.email}
                  </span>
                </div>
                <div className="adminUserdetails-viewmodal-detail-item">
                  <span className="adminUserdetails-viewmodal-label">City</span>
                  <span className="adminUserdetails-viewmodal-value">
                    {viewUser?.city}
                  </span>
                </div>
                <div className="adminUserdetails-viewmodal-detail-item">
                  <span className="adminUserdetails-viewmodal-label">Area</span>
                  <span className="adminUserdetails-viewmodal-value">
                    {viewUser?.area}
                  </span>
                </div>

                <div className="adminUserdetails-viewmodal-detail-item">
                  <span className="adminUserdetails-viewmodal-label">
                    Address
                  </span>
                  <span className="adminUserdetails-viewmodal-value">
                    {viewUser?.Address}
                  </span>
                </div>
                {/* <div className="adminUserdetails-viewmodal-detail-item">
                  <span className="adminUserdetails-viewmodal-label">
                    DOB
                  </span>
                  <span className="adminUserdetails-viewmodal-value">
                    {viewUser?.dob
                      ? new Date(viewUser?.dob).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      : ""}
                  </span>
                </div> */}
                {/* <div className="adminUserdetails-viewmodal-detail-item">
                  <span className="adminUserdetails-viewmodal-label">
                    Gender
                  </span>
                  <span className="adminUserdetails-viewmodal-value">
                    {viewUser?.gender}
                  </span>
                </div> */}
                <div className="adminUserdetails-viewmodal-detail-item">
                  <span className="adminUserdetails-viewmodal-label">
                    Rating
                  </span>
                  <span className="adminUserdetails-viewmodal-value">
                    <i className="fas fa-star me-1 text-warning"></i>
                    {viewUser?.rating ?? "N/A"}
                  </span>
                </div>
                <div className="adminUserdetails-viewmodal-detail-item">
                  <span className="adminUserdetails-viewmodal-label">
                    Penalty Count
                  </span>
                  <span className="adminUserdetails-viewmodal-value">
                    {viewUser?.penaltyCount ?? "N/A"}
                  </span>
                </div>
                <div className="adminUserdetails-viewmodal-detail-item">
                  <span className="adminUserdetails-viewmodal-label">
                    Joined HelpNao
                  </span>
                  <span className="adminUserdetails-viewmodal-value">
                    {viewUser?.created_at
                      ? new Date(viewUser?.created_at).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          },
                        )
                      : ""}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Order Counts Section */}
          <div className="adminUserdetails-viewmodal-full-section">
            <h4 className="adminUserdetails-viewmodal-section-title">
              Order Statistics
            </h4>
            <div className="adminUserdetails-viewmodal-counts-grid">
              <div className="adminUserdetails-viewmodal-count-item">
                <span className="adminUserdetails-viewmodal-count-label">
                  Total Orders
                </span>
                <span className="adminUserdetails-viewmodal-count-value">
                  {totalOrders}
                </span>
              </div>
              <div className="adminUserdetails-viewmodal-count-item">
                <span className="adminUserdetails-viewmodal-count-label">
                  Completed
                </span>
                <span className="adminUserdetails-viewmodal-count-value">
                  {completedOrders}
                </span>
              </div>
              <div className="adminUserdetails-viewmodal-count-item">
                <span className="adminUserdetails-viewmodal-count-label">
                  Cancelled
                </span>
                <span className="adminUserdetails-viewmodal-count-value">
                  {canceledOrders}
                </span>
              </div>
              <div className="adminUserdetails-viewmodal-count-item">
                <span className="adminUserdetails-viewmodal-count-label">
                  Cancelled by Servitor
                </span>
                <span className="adminUserdetails-viewmodal-count-value">
                  {canceledByServitor}
                </span>
              </div>
              <div className="adminUserdetails-viewmodal-count-item">
                <span className="adminUserdetails-viewmodal-count-label">
                  Deadline Timeout
                </span>
                <span className="adminUserdetails-viewmodal-count-value">
                  {deadlineTimeout}
                </span>
              </div>
              <div className="adminUserdetails-viewmodal-count-item">
                <span className="adminUserdetails-viewmodal-count-label">
                  Accepted
                </span>
                <span className="adminUserdetails-viewmodal-count-value">
                  {acceptedOrders}
                </span>
              </div>
            </div>
          </div>

          {/* Orders List */}
          <div className="adminUserdetails-viewmodal-full-section">
            <h4 className="adminUserdetails-viewmodal-section-title">
              Order List
            </h4>
            {viewOrders.length === 0 ? (
              <p className="text-center text-muted">No orders found.</p>
            ) : (
              <Table striped hover size="sm" style={{ fontSize: "14px" }}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Order #</th>
                    <th>Service</th>
                    <th>Status</th>
                    <th>Price</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {viewOrders.map((o, i) => (
                    <tr key={o.order_number || i}>
                      <td>{i + 1}</td>
                      <td>{o.order_number}</td>
                      <td>{o.Service?.services_name || o.service_name}</td>
                      <td>{o.status}</td>
                      <td>{o.price}</td>
                      <td>
                        {o.created_at
                          ? new Date(o.created_at).toLocaleDateString()
                          : ""}{" "}
                        <br />
                        {o.created_at
                          ? new Date(o.created_at).toLocaleTimeString()
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="adminUserdetails-modal-footer">
          <Button
            variant="secondary"
            onClick={handleCloseViewModal}
            className="adminUserdetails-footer-btn adminUserdetails-footer-btn-close"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {errorMessage && (
        <Alert
          variant={errorMessage.includes("successfully") ? "success" : "danger"}
          onClose={() => setErrorMessage("")}
          dismissible
        >
          {errorMessage}
        </Alert>
      )}

      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        centered
        size="lg"
        className="adminUserdetails-modal"
      >
        <Modal.Header closeButton className="adminUserdetails-modal-header">
          <Modal.Title>User Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="adminUserdetails-modal-body text-center">
          <Image src={imageSrc} alt="Preview" fluid />
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default UserDetails;
